import { useState } from "react";
import {
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
} from "@mui/material";
import { Menu as MenuIcon, Music } from "lucide-react";
import Logo from "../../Static/RoundedRTSIcon.png";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <List>
      {[
        { text: "Company", href: "/#team" },
        { text: "Blogs", href: "/blog" },
        { text: "Services", href: "/#services" },
        { text: "Testimonials", href: "/#testimonials" },
        { text: "Contact Us", href: "/#contact" },
        { text: "Tools", href: "/tools" },
      ].map((item) => (
        <ListItem button key={item.text} component="a" href={item.href}>
          <ListItemText primary={item.text} />
        </ListItem>
      ))}
    </List>
  );

  return (
    <header className="py-2 px-4 md:px-6 lg:px-8 flex items-center shadow-xl justify-between bg-white sticky top-0 z-40 w-full ">
      {/* Brand Logo */}
      <div className="flex items-center space-x-3">
        <a href="/">
          <img src={Logo} alt="Rohan's Tax Services" height={50} width={50} />
        </a>
        <div>
          <span className="text-lg sm:tetxt-xl font-bold text-[#151C62]">
            Rohan's Tax Services
          </span>
          <div className="text-xs text-center font-bold text-[#151C62]">
            Tax Practitioner
          </div>
        </div>
      </div>

      {/* Desktop Navigation (Visible only on Medium Screens and Larger) */}
      <nav className="hidden md:flex items-center space-x-6">
        <a
          href="/#team"
          className="text-sm font-medium hover:text-primary transition-colors"
        >
          Company
        </a>
        <a
          href="/blog"
          className="text-sm font-medium hover:text-primary transition-colors"
        >
          Blogs
        </a>
        <a
          href="/#services"
          className="text-sm font-medium hover:text-primary transition-colors"
        >
          Services
        </a>
        <a
          href="/#testimonials"
          className="text-sm font-medium hover:text-primary transition-colors"
        >
          Testimonials
        </a>
        <a
          href="/#contact"
          className="text-sm font-medium hover:text-primary transition-colors"
        >
          Contact Us
        </a>
        <a
          href="/tools"
          className="text-sm font-medium hover:text-primary transition-colors"
        >
          Tools
        </a>
      </nav>

      {/* Hamburger Menu (Visible only on Small Screens) */}
      <div className="md:hidden">
        <IconButton onClick={handleDrawerToggle} aria-label="menu">
          <MenuIcon />
        </IconButton>
        <Drawer
          anchor="right"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          sx={{
            "& .MuiDrawer-paper": {
              width: 250,
            },
          }}
        >
          {drawer}
        </Drawer>
      </div>
    </header>
  );
}
